import * as React from "react";
function SvgFavoriteEmpty(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.323 10.643L12 7.775l-1.323 2.868-3.136.371L9.86 13.16l-.616 3.097L12 14.713l2.756 1.543-.616-3.098 2.319-2.144-3.136-.371zm6.3-1.267a.64.64 0 01.358 1.105l-3.661 3.386.972 4.891a.64.64 0 01-.94.683L12 17.006 7.648 19.44a.64.64 0 01-.94-.683l.972-4.891-3.661-3.386a.64.64 0 01.359-1.105l4.952-.588L11.42 4.26a.64.64 0 011.162 0l2.089 4.528 4.952.588z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgFavoriteEmpty);
export default ForwardRef;
